import { Toaster } from 'sonner'

export const SetupToaster = (): React.ReactNode => {
    return (
        <Toaster
            className='toaster'
            mobileOffset={{ bottom: 100, left: 16, right: 16 }}
            position='bottom-center'
            visibleToasts={1}
            toastOptions={{
                classNames: {
                    toast: 'toaster__toast',
                    content: 'toaster__content',
                },
            }}
        />
    )
}
